'use-client';
import * as React from 'react';
import type { IResponsivePopupPageProps } from '../../../ResponsivePopupPage.types';
import ResponsivePopupPage from '../../ResponsivePopupPage';

const WithoutOverlay: React.FC<IResponsivePopupPageProps> = props => {
  return <ResponsivePopupPage {...props} withOverlay={false} />;
};

export default WithoutOverlay;
